import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import {
  StapleTable,
  StapleTableHeader,
  StapleTableRow,
  StapleTableHeading,
  StapleTableBody,
  IMFormModal,
  ActionModal,
  IMInputText,
  colors,
  Alert,
} from '@insurancemenu/imenu-components-lib';
import { toJS } from 'mobx';
import { ModalType } from '@insurancemenu/imenu-components-lib/dist/helpers/ModalsHelper';
import { useFavoriteProposalsPageStore } from 'store/pages/tools/favorite-proposals/pageStore';
import { Description } from '@insurancemenu/imenu-components-lib/dist/icons';
import { ProposalNameStyled } from './styles';
import FavoriteProposalsRow from './FavoriteProposalsRow';
import { RENAME_PROPOSAL_FORM_ID } from './constants';

const FavoriteProposalsTable = observer((): JSX.Element => {
  const {
    isLoading,
    carts,
    currentCartName,
    deleteModalDelegate,
    renameModalDelegate,
    renameForm,
    getInitialData,
    closeDeleteModal,
    closeRenameModal,
    deleteProposal,
  } = useFavoriteProposalsPageStore();

  const convertedCarts = carts.map((cart) => toJS(cart)).slice();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <>
      <StapleTable loading={isLoading} totalElements={convertedCarts.length}>
        <StapleTableHeader>
          <StapleTableRow>
            <StapleTableHeading width="12rem">Proposal Name</StapleTableHeading>
            <StapleTableHeading width="8rem">Product Lines</StapleTableHeading>
            <StapleTableHeading width="6rem">Last modified</StapleTableHeading>
            <StapleTableHeading width="5rem" />
          </StapleTableRow>
        </StapleTableHeader>
        <StapleTableBody>
          {convertedCarts.map((cart) => (
            <FavoriteProposalsRow key={cart.id} cart={cart} />
          ))}
        </StapleTableBody>
      </StapleTable>

      <ActionModal
        show={deleteModalDelegate.isVisible}
        title="Delete Proposal"
        loading={deleteModalDelegate.isLoading}
        subtitle={
          <p>
            You are about to delete
            <ProposalNameStyled>{currentCartName}.</ProposalNameStyled> Once deleted, this proposal can no longer be
            used as a favorite during Proposal Creation
          </p>
        }
        actionButtonText="Delete Proposal"
        closeButtonText="Cancel"
        onClose={closeDeleteModal}
        onAction={deleteProposal}
        modalType={ModalType.DELETE}
      />

      <IMFormModal
        show={renameModalDelegate.isVisible}
        title="Rename Proposal"
        subtitle="Update the proposal name below"
        formId={RENAME_PROPOSAL_FORM_ID}
        icon={<Description color={colors.green[600]} width="5.6rem" height="5.6rem" />}
        closeButtonText="Cancel"
        submitButtonText="Save"
        onClose={closeRenameModal}
        formController={renameForm}
        formContent={
          <>
            <IMInputText label="Proposal Name" name="cartName" size="full" />
            <Alert
              type="info"
              content={[
                <span key="0">
                  <b>Note: </b>
                  This name will be displayed in the Favorite Proposal list during Proposal Creation. Use a descriptive
                  name so it is easy to identify.
                </span>,
              ]}
            />
          </>
        }
      />
    </>
  );
});

export default FavoriteProposalsTable;
